<mat-expansion-panel [expanded]="true">
  <mat-expansion-panel-header>
    <mat-panel-title>
      {{ 'event.shortInfo' | translate }}
    </mat-panel-title>
  </mat-expansion-panel-header>
  <div class="small-content">
    <div class="small">
      <event-block-component [event]="eventData()"></event-block-component>
    </div>
    @if (eventData().reservationPossible) {
      <div [ngClass]="{'tab-min-width': participantCount() || waitlistCount()}">
        <mat-tab-group class="new-event-tabs-detail">
          @if (participantKeys()) {
            <mat-tab>
              <ng-template mat-tab-label>
                <span matBadge="{{participantCount()}}"
                      matBadgeOverlap="false"> {{ 'event.participants' | translate }}</span>
              </ng-template>
              <div class="p-24 will-be-soon">
                <participant-component (update)="updateParticipant()"
                                 (updateSubEvents)="updateSubEvents()"
                                 (count)="setParticipantCount($event)" [type]="'participants'"
                                 [participants]="participants()"
                                 [subEvents]="subEventWithBooking()"
                                 [isEdit]="eventData()?.editButton || eventData()?.editParticipant"
                                 [blockEditCredit]="eventData()?.blockEditCredit"
                                 [eventData]="eventData()"></participant-component>
              </div>
            </mat-tab>
          }
          @if (waitingListKeys()) {
            <mat-tab>
              <ng-template mat-tab-label>
                <span matBadge="{{waitlistCount()}}" matBadgeOverlap="false"> {{ 'event.waitingList' | translate }}</span>
              </ng-template>
              <div class="p-24 will-be-soon">
                <participant-component (update)="updateParticipant()"
                                 (updateSubEvents)="updateSubEvents()"
                                 (count)="setWaitingListCount($event)"
                                 [subEvents]="subEventWithBooking()"
                                 [type]="'waitingList'" [participants]="waitingList()"
                                 [isEdit]="eventData()?.editButton || eventData()?.editParticipant"
                                 [blockEditCredit]="eventData()?.blockEditCredit"
                ></participant-component>
              </div>
            </mat-tab>
          }
        </mat-tab-group>
      </div>
    }
  </div>
</mat-expansion-panel>
<mat-expansion-panel [expanded]="true">
  <mat-expansion-panel-header>
    <mat-panel-title>
      {{ 'event.fullInfo' | translate }}
    </mat-panel-title>
  </mat-expansion-panel-header>
  <div class="big">
    <event-description-component [event]="eventData()" [participant]="participantCount()"></event-description-component>
  </div>
  @if (eventData()?.editButton) {
    @if (getSupportRequirements().length) {
      <mat-card class="card-container">
        <mat-card-header>
          <mat-card-title>{{ 'event.record_support_requirements' | translate }}</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <document-component [type]="'newEvent'" [uniqueId]="'supportRequirements'" [readOnly]="true"
                              [uploadedFilesInput]="getSupportRequirements()"></document-component>
        </mat-card-content>
      </mat-card>
    }
    @if (getConditionsOfParticipation().length) {
      <mat-card class="card-container">
        <mat-card-header>
          <mat-card-title>{{ 'event.display_conditions_of_participation' | translate }}</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <document-component [type]="'newEvent'" [uniqueId]="'conditionsOfParticipation'" [readOnly]="true"
                              [uploadedFilesInput]="getConditionsOfParticipation()"></document-component>
        </mat-card-content>
      </mat-card>
    }
    @if (getEventDocuments().length) {
      <mat-card class="card-container">
        <mat-card-header>
          <mat-card-title>{{ 'event.upload_documents' | translate }}</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <document-component [type]="'newEvent'" [uniqueId]="'documents'" [readOnly]="true"
                              [uploadedFilesInput]="getEventDocuments()"></document-component>
        </mat-card-content>
      </mat-card>
    }
  }
</mat-expansion-panel>
@if (eventData()?.unSubscribeButon || eventData()?.subscribeButon) {
  <mat-expansion-panel [expanded]="true">
    <mat-expansion-panel-header>
      <mat-panel-title>
        {{ 'event.technical_information' | translate }}
      </mat-panel-title>
    </mat-expansion-panel-header>
    <div class="technical-information">
      @if (eventData()?.dates) {
        <div class="ti-container">
          <div class="ti-title">{{ 'event.dates' | translate }}:</div>
          <div class="ti-info">{{ eventData()?.dates }}</div>
        </div>
      }
      @if (eventData()?.dateVisibleFrom) {
        <div class="ti-container">
          <div class="ti-title">{{ 'event.date_visible_from' | translate }}:</div>
          <div class="ti-info">{{ eventData()?.dateVisibleFrom }}</div>
        </div>
      }
      @if (eventData()?.dateVisibleTo) {
        <div class="ti-container">
          <div class="ti-title">{{ 'event.date_visible_to' | translate }}:</div>
          <div class="ti-info">{{ eventData()?.dateVisibleTo }}</div>
        </div>
      }
    </div>
  </mat-expansion-panel>
}
